import React from "react";

interface Props {
    item: string;
    colourVariant: string;
}

const Badge = ({
    item,
    colourVariant = "brand",
} : Props) => {
    return (
        <div key={item.toLowerCase().replace(/^0-9a-z/, "_")}
             className={`py-1 px-2 text-xs text-${colourVariant}-900 bg-${colourVariant}-300 dark:text-white dark:bg-${colourVariant}-500 font-bold rounded-full`}
        >
            {item}
        </div>
    );
};

export default Badge;